import { AuthenticationService } from '../../authentication/services/AuthenticationService';
import { UserSettingsActions } from '../services/UserSettingsActions';

export class UserActions {

  public signout() {
    AuthenticationService.signOut();
  }

  public changeUserStartPage() {
    UserSettingsActions.confirmChangeUserStartPage();
  }

  public changeServerDefaultStartPage() {
    UserSettingsActions.confirmChangeServerDefaultStartPage();
  }

  public changeSiteStartPage() {
    UserSettingsActions.confirmChangeSiteStartPage();
  }

}
